import CouchTopLineComponent from '~/viewportGrid/adapters/engine/overlays/CouchTopLine';
import type { Environment } from '~/engine/data/Environment';
import { RenderAdapter } from '~/viewportGrid/adapters/types';
import { usePlaneViewHostedBy } from '../usePlaneViewHostedBy';

interface TileCouchTopLineMountProps {
    renderer: RenderAdapter;
    /** The Environment whose tiles draw the couch-top line; undefined hides it. */
    couchHost: Environment | undefined;
}

/**
 * Mounts the couch-top line over one grid tile, and only on a tile of the
 * Environment that hosts it, so the line never lands on another row. The
 * line owns which of those tiles it draws on (the image's own slice plane,
 * drawing the primary image) and when (while the couch panel is open);
 * this mount owns nothing but the host gate. Renders nothing for
 * non-engine renderers (the mock adapters).
 */
export default function TileCouchTopLineMount({
    renderer,
    couchHost,
}: TileCouchTopLineMountProps) {
    const view = usePlaneViewHostedBy(renderer, couchHost);
    if (!view) {
        return null;
    }
    return <CouchTopLineComponent view={view} />;
}
